import Check from './check.svg';

export default Check;
